import type { CSSProperties } from 'react';

export interface AvatarProps {
  name?: string;
  size?: number;
  /** Override deterministic palette color. */
  tone?: string;
  style?: CSSProperties;
  className?: string;
}

const PALETTE = ['#1d4ed8', '#16a34a', '#7c3aed', '#db2777', '#ea580c', '#0891b2', '#65a30d'];

function deterministicColor(name: string): string {
  const a = name.charCodeAt(0) || 0;
  const b = name.charCodeAt(1) || 0;
  return PALETTE[(a + b) % PALETTE.length];
}

function initialsOf(name: string): string {
  return name
    .split(' ')
    .map((p) => p[0] ?? '')
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

export function Avatar({ name = 'AB', size = 28, tone, style, className }: AvatarProps) {
  const bg = tone ?? deterministicColor(name);
  const initials = initialsOf(name);
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        background: bg,
        color: 'white',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size * 0.42,
        fontWeight: 600,
        letterSpacing: '-0.01em',
        flexShrink: 0,
        ...style,
      }}
    >
      {initials}
    </div>
  );
}
